import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { AuthService } from '../../../auth/auth.service';
import {csLegacyUrl} from "../../../constants";

const ACCESS_DENIED_TITLE_KEY = 'Access Denied';

@Component({
  selector: 'app-access-denied',
  templateUrl: './app-access-denied.component.html',
})
export class AppAccessDeniedComponent implements OnInit {
  public pageTitle = '';
  public csLegacyUrl = '';

  constructor(private translate: TranslateService,
              private authService: AuthService) { }

  public ngOnInit(): void {
    this.authService.logout();

    this.csLegacyUrl = csLegacyUrl;

    this.translate.get(ACCESS_DENIED_TITLE_KEY).pipe(take(1)).subscribe(title => {
      this.pageTitle = title;
    });
  }
}
